/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import InputType from '@linc-technologies/linced-common/enums/input-type';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';
import { action } from '@ember/object';

export default class ApplyLimit extends Component {
  // Services
  @service
  store;

  event = null;
  option = null;
  @tracked
  optionLimit = null;

  @tracked
  dialogOpen;

  @action
  openDialog() {
    let optionLimit;
    if (this.event.optionLimits) {
      optionLimit = findBy(
        this.event.optionLimits,
        'optionId',
        this.option.key,
      );
    }
    if (!optionLimit) {
      optionLimit = this.store.createFragment('events/option-limit', {
        optionId: this.option.key,
        limit: 0,
      });
      if (
        [InputType.CHECKBOX, InputType.RADIO, InputType.SELECT].includes(
          this.option.inputType,
        )
      ) {
        this.option.options.forEach((selection) => {
          let valueLimit = this.store.createFragment('events/value-limit', {
            value: selection.value,
            limit: 0,
          });
          optionLimit.valueLimits.addFragment(valueLimit);
        });
      }
      this.event.optionLimits.addFragment(optionLimit);
    }
    this.optionLimit = optionLimit;
    this.dialogOpen = true;
  }
}
